<template>
    <div class="device-type-manange relative">
        <div class="buttons">
<!--            <el-button @click="resetForm">重置</el-button>-->
<!--            <el-button @click="search">筛选</el-button>-->
        </div>

        <!-- 表单开始 -->
        <el-row class="inputs mg-20" :gutter="20">
            <el-col :md="6" :lg="4" :xl="6">
                <span class="fs-14 pd-r-10">关键词搜索：</span>
                <el-input v-model="search_data" placeholder="请输入合约编号/姓名/联系电话关键词" style="width: 100%;"></el-input>
            </el-col>
            <el-col :md="6" :lg="5" :xl="6">
                <span class="fs-14 pd-r-10" v-if="contract_type != 5">签约时间：</span>
                <span class="fs-14 pd-r-10" v-if="contract_type == 5">缴费时间：</span>
                <el-date-picker
                    v-model="search_expired_date"
                    type="daterange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    value-format="yyyy-MM-dd"
                    @change="dateChange"
                ></el-date-picker>
            </el-col>
            <el-col :md="6" :lg="5" :xl="6">
                <span class="fs-14 pd-r-10">报表类型：</span>
                <el-select v-model="contract_type" placeholder="请选择类型" @change="roleChange" style="max-width: none !important;width: 100%;">
                    <el-option
                        v-for="item in types"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                    ></el-option>
                </el-select>
            </el-col>
            <el-col :md="6" :lg="5" :xl="6">
                <el-button @click="resetForm">重置</el-button>
                <el-button @click="search">筛选</el-button>
            </el-col>
        </el-row>

        <p style="float: left;" v-if="contract_type == 1">财务汇总 合约已缴费总金额（元）：{{allData}}</p>
        <p style="float: left;" v-if="contract_type == 5">财务汇总 缴费总金额（元）：{{allData}}</p>
        <el-table ref="multipleTable"
                  :data="tableData"
                  border
                  style="width: 100%"
                  :span-method="arraySpanMethod">
            <el-table-column width="50px" prop="no" label="序号" align="center" label-class-name="label"></el-table-column>
            <el-table-column prop="esign_flow_id" label="合约编号" align="center" label-class-name="label"></el-table-column>
            <el-table-column width="130" prop="user_name" label="姓名" align="center" label-class-name="label" v-if="role_id == 3"></el-table-column>
            <el-table-column width="100" prop="user_name" label="姓名" align="center" label-class-name="label" v-if="role_id != 3"></el-table-column>
            <el-table-column width="110" prop="mobile" label="联系电话" align="center" label-class-name="label" v-if="role_id == 3"></el-table-column>
            <el-table-column width="110" prop="mobile" label="联系电话" align="center" label-class-name="label" v-if="role_id != 3"></el-table-column>
            <el-table-column width="100" prop="doctor_name" label="签约专家" align="center" label-class-name="label" v-if="contract_type != 3"></el-table-column>
            <el-table-column width="130" prop="doctor_mobile" label="专家联系电话" align="center" label-class-name="label" v-if="contract_type != 3"></el-table-column>
            <el-table-column width="110" prop="esign_type_txt" label="合约类型" align="center" label-class-name="label" v-if="contract_type == 1"></el-table-column>
            <el-table-column prop="hospital_name" label="所属单位" align="center" label-class-name="label" v-if="contract_type == 3"></el-table-column>
            <el-table-column prop="department_name" label="所属科室" align="center" label-class-name="label" v-if="contract_type == 3"></el-table-column>
            <el-table-column width="130"  prop="title_name" label="职称" align="center" label-class-name="label" v-if="contract_type == 3"></el-table-column>
            <el-table-column width="130"  prop="contract_date" label="签约时间" align="center" label-class-name="label" v-if="role_id == 3"></el-table-column>
            <el-table-column width="130" prop="contract_date" label="签约时间" align="center" label-class-name="label" v-if="role_id != 3"></el-table-column>
            <el-table-column width="110" prop="esign_pay_type" label="付款方式" align="center" label-class-name="label" v-if="contract_type == 1"></el-table-column>
            <el-table-column width="90" prop="amount" label="合约总额" align="center" label-class-name="label" v-if="contract_type != 3"></el-table-column>
            <el-table-column width="90" prop="pay_amount" label="缴费金额" align="center" label-class-name="label" v-if="contract_type == 5"></el-table-column>
            <el-table-column width="160" prop="pay_date" label="缴费时间" align="center" label-class-name="label" v-if="contract_type == 5"></el-table-column>
            <el-table-column width="90" prop="amount_type" label="费用类型" align="center" label-class-name="label" v-if="contract_type == 5"></el-table-column>
            <el-table-column width="100" prop="amount_pay_type_txt" label="支付方式" align="center" label-class-name="label" v-if="contract_type == 5"></el-table-column>
<!--            <el-table-column width="90" prop="amount_type" label="缴费类型" align="center" label-class-name="label" v-if="user_role == 5"></el-table-column>-->
            <el-table-column width="130" prop="pay_expired_date" label="付费到期时间" align="center" label-class-name="label" v-if="contract_type == 1"></el-table-column>
            <el-table-column width="160" label="操作" align="center" label-class-name="label" v-slot="scope">
                <el-button  @click="oneReservationDetail(scope.row)" type="text" size="mini">查看合约</el-button>
                <el-button  @click="downloadPdf(scope.row)" type="text" size="mini">下载合约</el-button>
            </el-table-column>
        </el-table>
        <el-pagination
                class="mg-20 ta-r"
                background
                layout="total, sizes, prev, pager, next, jumper"
                :page-sizes="[10, 25, 50, 100]"
                :total="total"
                :page-size="perpage"
                :current-page="page"
                @current-change="changePage"
                @size-change="changeSite"
        ></el-pagination>

        <el-dialog title="合约详情" :visible.sync="dialogContractFormVisible">
            <el-carousel indicator-position="none" height="700px" :autoplay="false" arrow="never" :loop="false">
                <el-carousel-item v-for="(url, n) in allContractUrls" :key="n">
                    <div class="image_box" style="height: 700px">
                        <pdf
                            v-for="i in url.pages"
                            :key="i"
                            :page="i"
                            :src="url.src"
                        ></pdf>
                    </div>
                </el-carousel-item>
            </el-carousel>
        </el-dialog>
    </div>
</template>
<script>
    import {export2Excel} from "@/utils/excel";
    import env from "@/api/env";
    import {check} from "@/utils/checkData";
    import pdf from "vue-pdf";
    import {fileType} from "@/api/order";
    import {getUserInfos} from "@/utils/userInfos";

    export default {
        components: {
            pdf,
        },
        data() {
            return {
                allContractUrls: [],
                dialogContractFormVisible: false,
                page: 1,
                perpage: 10,
                total: 0,
                tableData: [],
                search_expired_date:'',
                search_data: '',
                start_date: '',
                end_date: '',
                allData:0.00,
                role_id: '1',
                contract_type: '1',
                is_submit: false,
                types: [
                    {
                        id: '1',
                        name: '特属服务对象签约'
                    },
                    {
                        id: '3',
                        name: '特属专家签约'
                    },
                    {
                        id: '5',
                        name: '特属服务对象缴费'
                    },
                ],
            };
        },
        created() {
            let userInfo = getUserInfos()
            if (userInfo) {
                this.role_id = parseInt(userInfo.role_id)
                this.child_role_id = parseInt(userInfo.child_role_id)
            }
        },
        mounted() {
            this.getList();
        },
        methods: {
            // 下载合约
            downloadPdf(data){
                let url = env.IMG_COMMON_URL_PREFIX+ data.file_url
                var x = new XMLHttpRequest();
                x.open("GET", url, true);
                x.responseType = 'blob';
                x.onload=function(e) {
                    var url = window.URL.createObjectURL(x.response)
                    var a = document.createElement('a');
                    a.href = url
                    a.download = data.user_name+'.pdf';
                    a.click()
                }
                x.send();

            },
            roleChange() {
                this.page = 1;
                this.start_date = "";
                this.end_date = "";
                this.search_data = "";
                this.search_expired_date = "";
                this.getList();
            },
            arraySpanMethod({ row, column, rowIndex, columnIndex }) {
                // columnIndex 可能需要合并的数据列： 1、2、12、13、14
                if (columnIndex < 4 ) {
                    // if (rowIndex % 5 === 0) {
                    if (row.data_num == 1) {
                        return {
                            rowspan: row.user_number,
                            colspan: 1
                        };
                    } else {
                        return {
                            rowspan: 0,
                            colspan: 0
                        };
                    }
                }
            },
            // 获取所有医生
            getList() {
                let params = {
                    servername: 'Ruyi_StatementsServices',
                    method: 'contractEsignList',
                    pageinfo: {
                        page: this.page,
                        perpage: this.perpage,
                    },
                    params: {
                        user_role: this.contract_type,
                        start_date: this.start_date,
                        end_date: this.end_date,
                        search_data: this.search_data,
                    }
                };
                this.$api.service(params).then(res => {
                    if (!check(res)) {
                        this.is_submit = false;
                        return;
                    }
                    let n = 0;
                    for (let i = 0; i < res.data.data.list.list.length; i++) {

                        if (res.data.data.list.list[i].data_num == 1) {
                            // 序号
                            res.data.data.list.list[i].no = (this.page - 1) * this.perpage + n + 1
                            n++;
                        }

                    }
                    this.allData = res.data.data.list.amount_count;
                    this.tableData = res.data.data.list.list;
                    this.total = res.data.data.page.count;
                    this.is_submit = false;
                }).finally(()=>{
                    this.is_submit = false;
                });
            },

            // 改变每页条数
            changeSite(index) {
                this.perpage = index;
                this.getList();
            },

            //更换页码
            changePage(index) {
                this.page = index;
                this.getList();
            },

            // 重置按钮
            resetForm() {
                this.is_submit = true;
                this.contract_type = '1';
                this.page = 1;
                this.start_date = "";
                this.end_date = "";
                this.search_data = "";
                this.search_expired_date = "";
                this.getList();
            },
            dateChange(e){
                if (!e) {
                    this.search_expired_date = null
                    this.start_date = ''
                    this.end_date = ''
                }
            },
            // 搜索
            search() {
                if (this.is_submit) {
                    // 重复提交提醒
                    this.$message({
                        type: "warning",
                        message: '正在处理请求，请不要重复操作',
                        duration: 1500,
                    });
                    return;
                }
                this.is_submit = true;
                this.page = 1;
                if (this.search_expired_date) {
                    this.start_date = this.search_expired_date[0];
                    this.end_date = this.search_expired_date[1];
                }
                this.getList();
            },
            getFileType(url) {
                return fileType(url)
            },
            // 协议详情
            async oneReservationDetail(contract_data) {

                this.allContractUrls = [];
                let allContractUrls = [];
                let data = [];
                data.push({
                    url: env.IMG_COMMON_URL_PREFIX+ contract_data.file_url
                })
                if (data.length > 0) {
                    let url = '';
                    let local_url = '';
                    let num_pages = 0;
                    for (let i = 0; i < data.length; i++) {
                        local_url = url = data[i].url;
                        num_pages = 0;
                        if (this.getFileType(url) == 'pdf') {
                            url = pdf.createLoadingTask(url)
                            await url.promise.then(pdf => {
                                num_pages = pdf.numPages
                                allContractUrls.push({
                                    src: local_url,
                                    pages: num_pages
                                });
                            }).catch((e)=>{});

                        } else {
                            allContractUrls.push({
                                src: local_url,
                                pages: num_pages
                            });
                        }
                    }
                }
                this.allContractUrls = allContractUrls;
                this.dialogContractFormVisible = true;
            },


        }
    };
</script>
<style lang="scss">
    @import "@/styles/common.scss";

    .docker_buttons {
        float: right;
        margin: 30px 0px 8px 0px;

        .el-button {
            width: 150px;
            height: 32px;
            line-height: 7px;
        }
    }
    .el-dialog{
        margin-top: 5vh !important;
    }
    .image_box {
        height: 700px;
        overflow: hidden;
        overflow-y: auto;

        image {
            width: 100%;
        }
    }
</style>
